const PDOK_BASE = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1'; //config.PDOK_BASE_URL;
export async function pdokSuggest(query) {
    const url = `${PDOK_BASE}/suggest?q=${encodeURIComponent(query)}&rows=100&fl=id weergavenaam score`;
    const response = await fetch(url);
    if (!response.ok)
        throw new Error('PDOK suggest failed');
    const data = await response.json();
    return (data?.response?.docs ?? []);
}
export async function pdokLookup(id) {
    const url = `${PDOK_BASE}/lookup?id=${encodeURIComponent(id)}&fl=id woonplaatsnaam weergavenaam postcode centroide_ll huisnummer straatnaam`;
    const response = await fetch(url);
    if (!response.ok)
        throw new Error('PDOK lookup failed');
    const data = await response.json();
    return data?.response?.docs?.[0];
}
export function parsePdokCoordinates(centroide_ll) {
    // Format: "POINT(lon lat)"
    const match = centroide_ll?.match(/POINT\(([^ ]+) ([^ )]+)\)/);
    if (!match)
        return { lat: null, lng: null };
    return { lat: parseFloat(match[2]), lng: parseFloat(match[1]) };
}
